<div class="grid-x">
  <div class="cell small-12">
    Date Based on:
  </div>
  <div class="cell small-12">
    <select [(ngModel)]="sideEffect.configuration.dateType" (ngModelChange)="changeDateType()">
      @for (opt of dateOptions; track opt) {
        <option [value]="opt.id">{{opt.text}}</option>
      }
    </select>
  </div>
  @if (sideEffect.configuration.dateType === 'time') {
    <div class="grid-x full-width">
      <div class="cell small-7">
        <input type="number" [(ngModel)]="sideEffect.configuration.timeFrame" min="0" class="text-align-right" />
      </div>
      <div class="cell small-5 padding-left">
        days after submit.
      </div>
    </div>
  }
  @if (sideEffect.configuration.dateType === 'expression') {
    <div class="cell small-12">
      <rules-editor [type]="sideEffect.configuration.rule.name" [(rule)]="sideEffect.configuration.rule"></rules-editor>
    </div>
  }
  <div class="cell small-7">
    <h5 class="bold">Reviews</h5>
  </div>
  <div class="cell small-4 margin-left">
    <button class="button hollow" (click)="addReview()">Add Review</button>
  </div>
</div>
@for (review of sideEffect.configuration.reviews; track review; let i = $index) {
  <div>
    <div class="grid-x">
      <div class="cell small-8" (click)="editReview(i)" style="font-weight: bold; color: blue; cursor: pointer;">
        {{review.title}}
      </div>
      @if (i === sideEffect.configuration.reviews.length - 1) {
        <div class="cell small-3 margin-left">
          <button attr.aria-label="Delete Review {{review.title}}" (click)="deleteReview(i)"><span class="show-for-sr">Delete Review {{review.title}}</span><svg-icon icon="icon-trash" aria-hidden="true"></svg-icon></button>
        </div>
      }
      <hr/>
    </div>
  </div>
}
@if (selectedReview) {
  <div>
    <div class="grid-x">
      <div class="cell small-12">
        Title:
      </div>
      <div class="cell small-12">
        <input type="text" [(ngModel)]="selectedReview.title" placeholder="new" />
      </div>
      <div class="cell small-12">
        <input type="checkbox" name="chiefOrderGroup" [(ngModel)]="selectedReview.chiefOrderGroup">
        Chief's Order (assign group from authority type in template)
      </div>
      @if (!selectedReview?.chiefOrderGroup) {
        <div class="cell small-12">
          Select Group:
        </div>
      }
      @if (!selectedReview?.chiefOrderGroup) {
        <div class="cell small-12">
          <select [(ngModel)]="selectedReview.group">
            @for (group of availableGroups; track group) {
              <option [value]="group.id">{{group.displayName}}</option>
            }
          </select>
        </div>
      }
      <div class="cell small-12">
        Select type of Work Order to create:
      </div>
      <div class="cell small-12">
        <select [(ngModel)]="selectedReview.workOrderType">
          @for (workOrderType of availableWorkOrderTypes; track workOrderType) {
            <option [value]="workOrderType.id">{{workOrderType.text}}</option>
          }
        </select>
      </div>
      <div class="cell small-12">
        Should Approval be blocked by outstanding Work Orders:
      </div>
      <div class="cell small-12">
        <input type="checkbox" name="blockOnOtherOustandingWorkOrders" [(ngModel)]="selectedReview.blockOnOtherOustandingWorkOrders">
      </div>
      <div class="cell small-12">
        Transition to associate with the Review:
      </div>
      <div class="cell small-12">
        <select [(ngModel)]="selectedReview.transition" (ngModelChange)="changeTransition($event)">
          @for (transition of availableTransitions; track transition) {
            <option [value]="transition.key">{{transition.name}}</option>
          }
        </select>
        @if (showWarning) {
          <div style="color: red;">
            Another review level is already assigned to execute this transition!
          </div>
        }
      </div>
      @if (selectedReviewTransition && selectedReviewTransition.key !== '-1' && selectedReviewTransition.sideEffects && selectedReviewTransition.sideEffects.length > 0) {
        <div>
          {{selectedReviewTransition.name}} executes the following side effects:
          @for (sideEffect of selectedReviewTransition.sideEffects; track sideEffect) {
            <div class="cell small-12">
              {{sideEffect.label}}
            </div>
          }
        </div>
      }
      @if (selectedReviewTransition && selectedReviewTransition.key !== '-1' &&  (!selectedReviewTransition.sideEffects || selectedReviewTransition.sideEffects.length === 0)) {
        <div>
          {{selectedReviewTransition.name}} executes no side effects.
        </div>
      }
    </div>
  </div>
}